module.exports = {"130733001":"西湾子街道办","130733100":"西湾子镇","130733101":"高家营镇","130733200":"四台嘴乡","130733201":"红旗营乡","130733202":"石窑子乡","130733203":"驿马图乡","130733204":"石嘴子乡","130733205":"狮子沟乡","130733206":"清三营乡","130733207":"白旗乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/130733.json
// module id = 178
// module chunks = 0